import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { AGENT_LIST, AGENT_LIST_SUCCESS, AGENT_LIST_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getAgentList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/agents`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: AGENT_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: AGENT_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: AGENT_LIST_ERROR, payload: error });
  }
}

export function* watchAgentList() {
  yield takeEvery(AGENT_LIST, getAgentList);
}

function* watchAgentListSaga() {
  yield all([fork(watchAgentList)]);
}

export default watchAgentListSaga;
